import { DATA_HUB, DATA_PERFORMANCE_LIST, NAVIGATION_HUB_READ, INSTRUMENT_LIST, INSTRUMENT_GET, CORPORATE_ACTION_LIST, CORPORATE_ACTION_GET, FACT_LIST, FACT_GET, FACT_BATCHES_LIST, FACT_BATCH_GET, IMPORT_LIST, IMPORT_GET, IMPORT_ROWS_LIST, RECONCILIATION_LIST, RECONCILIATION_GET, RECONCILIATION_RUN_LIST, RECONCILIATION_RUN_GET, RECONCILIATION_STATEMENT_LIST, RECONCILIATION_STATEMENT_GET, } from '../../operations/operation-ids.js';
/**
 * Organization data reader: read access to Data Hub reference, operational,
 * exceptions, fact, and governed portfolio-performance surfaces.
 */
export const ORGANIZATION_DATA_READER_OPERATIONS = [
    DATA_HUB,
    DATA_PERFORMANCE_LIST,
    NAVIGATION_HUB_READ,
    INSTRUMENT_LIST,
    INSTRUMENT_GET,
    CORPORATE_ACTION_LIST,
    CORPORATE_ACTION_GET,
    FACT_LIST,
    FACT_GET,
    FACT_BATCHES_LIST,
    FACT_BATCH_GET,
    IMPORT_LIST,
    IMPORT_GET,
    IMPORT_ROWS_LIST,
    RECONCILIATION_LIST,
    RECONCILIATION_GET,
    RECONCILIATION_RUN_LIST,
    RECONCILIATION_RUN_GET,
    RECONCILIATION_STATEMENT_LIST,
    RECONCILIATION_STATEMENT_GET,
];
